import './evento-agenda-rte.scss';

/**
 * version    1.0
 * class      <type> (evento-agenda-rte)
 * classdesc  Component that manage evento agenda rte
 */
export class EventoAgendaRte {}
